var map = {
	"./404-error.png": 7104,
	"./CDPLC.png": 6074,
	"./Email.png": 2225,
	"./Notification.png": 5093,
	"./SMS.png": 4146,
	"./a.png": 1507,
	"./approval.png": 3963,
	"./arrived.png": 4929,
	"./attach-file.png": 2423,
	"./attendance.png": 3769,
	"./attendanceendorsment.png": 3868,
	"./b.png": 3034,
	"./booking.png": 8090,
	"./briefcase.png": 5796,
	"./c.png": 9900,
	"./calendar.png": 3611,
	"./cart.png": 6393,
	"./chatbot.png": 2563,
	"./connectionError.png": 1239,
	"./ex_hours.png": 2458,
	"./exit.png": 8763,
	"./food.png": 1910,
	"./gallery.png": 5816,
	"./healthcare.png": 3686,
	"./maintenance.png": 9347,
	"./personal.png": 9325,
	"./reservation.png": 83,
	"./scanner.png": 6004,
	"./settings.png": 4476,
	"./store.png": 6310,
	"./telephonedirectory.png": 5123,
	"./time_endoresement.png": 9239,
	"./to-do-list.png": 1715,
	"./tools.png": 7832,
	"./user-check.png": 5024,
	"./user.png": 856,
	"./welfare.png": 6581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;